import { Container, Typography } from '@mui/material';

// Store is needed here to handle async load time race condition
// since the LoadingScreenContainer is not using code splitting,
// it must be loaded early.
import store from '../../../redux/store';

import useStyles from '../../../styling/jss';
import animation from '../../../assets/images/animationLoading.gif';
import intelyConnectText from '../../../assets/images/intelyConnectText.png';

import {
    getUserLogin,
    restoreUserSessionStates,
    redirectUserTokenExpired,
    updateUserLastRefreshTime,
    updateUserLastActivityTime,
    setupAuthUserDataWithStore,
    getDefaultOrganizationIdUrlParameter,
    getCurrentSelectedOrganizationId,
} from '../../../utils/loginUtils';
import { prepareAppDataGlobally } from '../../../hooks/usePrepareAppDataGloballyHook';
import { Cookies } from 'react-cookie';
import { CURRENT_ORGANIZATION_ID_KEY, CURRENT_DOMAIN_SUFFIX } from '../../../utils/constants';

const LoadingScreenContainer = () => {
    const classes = useStyles()();

    window.onload = async function () {
        const cookies = new Cookies();
        const urlParameterOrganizationId = getDefaultOrganizationIdUrlParameter();
        // An invalid parameter is ignored but still removed from the URL below.
        const hasLoadedOrganizationIdFromUrlParameters = new URLSearchParams(window.location.search).has(
            'currentOrganizationId',
        );

        // Set the current organization ID from the URL parameter, else the platform's organization cookie, else local
        // storage. The cookie below is the PLATFORM's (same name, shared domain): Connect used to rewrite it from its
        // own local storage on every load, so opening Connect through a link without the parameter silently moved
        // the platform to whichever organization Connect last used (DEV-5711). Following the cookie keeps the two on
        // one organization; Connect's own organization menu writes the cookie too (Header).
        const defaultOrganizationId =
            urlParameterOrganizationId ||
            cookies.get(CURRENT_ORGANIZATION_ID_KEY) ||
            getCurrentSelectedOrganizationId();
        if (defaultOrganizationId) {
            localStorage.setItem(CURRENT_ORGANIZATION_ID_KEY, defaultOrganizationId);
        }

        // Validate the user token and get the user login data
        const loginResults = await getUserLogin();

        // Get the current organization ID from the user token if it was not set from the URL or local storage
        if (!defaultOrganizationId) {
            localStorage.setItem(CURRENT_ORGANIZATION_ID_KEY, loginResults.defaultOrganizationId);
        }

        cookies.set(CURRENT_ORGANIZATION_ID_KEY, localStorage.getItem(CURRENT_ORGANIZATION_ID_KEY), {
            path: '/',
            domain: CURRENT_DOMAIN_SUFFIX,
            secure: true,
        });

        // Remove currentOrganizationId from the URL if it was set from the URL
        if (hasLoadedOrganizationIdFromUrlParameters) {
            const params = new URLSearchParams(window.location.search);
            params.delete('currentOrganizationId');
            window.location.replace(window.location.pathname + (params.toString() ? '?' + params : ''));
            return;
        }

        if (loginResults !== false) {
            await setupAuthUserDataWithStore(store, loginResults);

            prepareAppDataGlobally();

            updateUserLastRefreshTime();
            updateUserLastActivityTime();
            restoreUserSessionStates();
        } else {
            redirectUserTokenExpired();
        }
    };

    return (
        <Container
            component="main"
            maxWidth="xs"
            style={{
                height: '-webkit-fill-available',
                display: 'flex',
                alignItems: 'center',
                overflow: 'auto',
                marginTop: '4rem',
                padding: '0 10px',
                justifyContent: null,
            }}
        >
            <div className={classes.bottomdiv} style={{ wordBreak: 'break-all' }}>
                <img src={animation} alt="img2 Icon" />
                <Typography>
                    <img src={intelyConnectText} style={{ width: '100%' }} alt="connecttext Icon" />
                </Typography>
            </div>
        </Container>
    );
};

export default LoadingScreenContainer;
